import {
  IRegistrationOrderConfirmationImages,
  RegFlowConfig,
  updateRegistrationData,
} from '@commerce-profile-webcomponents/sdk';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { type AppDispatch, type AppState } from '@nextgen-web-framework/core';
import { useBreakpoint, useSession } from '@nextgen-web-framework/all';
import { RegistrationErrorCard } from '../Common/RegistrationErrorCard/RegistrationErrorCard';
import { RegistrationErrorCardConfig } from '../../utils/Constants';
import { RegistrationErrorCardProps } from '../Common/RegistrationErrorCard/types/propsTypes';
import { RegistrationSuccessComponent } from '../RegistrationSuccessComponent/RegistrationSuccessComponent';
import { IRegistrationConfirmationPropTypes } from './types/propTypes';

const RegistrationConfirmation = (props: IRegistrationConfirmationPropTypes) => {
  const { errorCode, flowName } = props;
  const viewPort = useBreakpoint();
  const dispatch = useDispatch<AppDispatch>();
  const [errorCardData, setErrorCardData] = useState<RegistrationErrorCardProps>();
  const [thankyouMsg, setThankyouMsg] = useState<string>();
  const cmsImageInfo = useSelector(
    (state: AppState) => state.commerceProfile.registrationOrderConfirmationImagesCMSData,
  ) as IRegistrationOrderConfirmationImages[];
  const { isAnonymous } = useSession();

  const getErrorCardConfig = (code: string) => {
    const selectedErrorCardConfig = RegistrationErrorCardConfig[code] ?? RegistrationErrorCardConfig['default'];
    setErrorCardData({
      ...selectedErrorCardConfig,
    });
  };

  const fetchCmsImage = () => {
    if (cmsImageInfo && Number(cmsImageInfo?.length) > 0) {
      const imageData: IRegistrationOrderConfirmationImages | undefined = cmsImageInfo.find(
        (imgObj: IRegistrationOrderConfirmationImages) => imgObj?.viewport?.includes(viewPort),
      );
      return imageData?.image?.url || '';
    }
    return '';
  };

  useEffect(() => {
    if (errorCode) {
      getErrorCardConfig(errorCode);
    }
  }, [errorCode]);

  useEffect(() => {
    if (flowName === RegFlowConfig.AboLedFlow && !isAnonymous()) {
      setThankyouMsg('profile.RegistrationConfirmation.AboLedthankMessage');
    } else {
      setThankyouMsg('profile.RegistrationConfirmation.thankMessage');
    }
    dispatch(
      updateRegistrationData({
        personalDetails: {},
        documentDataList: [],
      }),
    );
  }, [flowName]);

  return errorCardData?.title ? (
    <RegistrationErrorCard {...errorCardData} />
  ) : (
    <RegistrationSuccessComponent {...props} message={thankyouMsg} imageUrl={fetchCmsImage()} flowName={flowName} />
  );
};

export default RegistrationConfirmation;
